module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Hacks-Structure-Your-Day-Deep-Dive-1.6d894a77.png";